import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'scripts/react-components/themes/Theme'

const popoverContentAreaStyles = ({ theme }: Theme) => css`
  label: popover-content-area;
  position: relative;

  width: 180px;
  color: ${theme.colors.n800};
  font-size: ${theme.typography.text.kilo.fontSize};
  font-weight: ${theme.font.weight.regular};
  line-height: 120%;
`

const closeButtonStyles = ({ theme }: Theme) => css`
  label: close-button;

  float: right;
  padding: ${theme.spacings.bit};
  margin-right: -${theme.spacings.kilo};
  margin-top: -${theme.spacings.kilo};
`
export const PopoverContent = styled('div')(popoverContentAreaStyles)
export const CloseButton = styled('button')(closeButtonStyles)
